import styled from 'styled-components';
import { mq } from '../../styles/mq';
export const IntroductionContainer = styled.div`
  padding-top: 6rem;
  ${mq.smallOnly} {
    padding-top: 5rem;
  }
  width: 100%;
  p {
    font-size: 1.7rem;
    margin: 2rem 0;
    ${mq.xlarge} {
      font-size: 2rem;
      line-height: 3rem;
    }
  }
`;
export const IntroductionImage = styled.div`
  position: relative;
  width: 100%;
  h1 {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    max-width: 66rem;
    margin: auto;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 3.3rem;
    font-weight: 800;
    line-height: 1.3;
    padding: 1rem;
    ${mq.medium} {
      font-size: 4.5rem;
    }
    ${mq.xlarge} {
      font-size: 6rem;
      max-width: 86rem;
    }
    span {
      font-weight: 800;
      display: block;
    }
  }
  img {
    width: 100%;
  }
`;
